var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "member-info" }, [
    _c("div", { staticClass: "member-info-box" }, [
      _vm._m(0),
      _c("div", { staticClass: "member-info-box-content" }, [
        _c("div", { staticClass: "member-info-box-text" }, [
          _vm._v(_vm._s(_vm.memberInfo.memberLevelName)),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "member-info-box" }, [
      _c(
        "div",
        { staticClass: "member-info-box-title" },
        [
          _c("div", [_vm._v("可用积分")]),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "has-permi",
                  rawName: "v-has-permi",
                  value: ["user_send_score"],
                  expression: "['user_send_score']",
                },
              ],
              staticStyle: { "margin-left": "8px" },
              attrs: { size: "mini", type: "text" },
              on: {
                click: function ($event) {
                  return _vm.handleScore(_vm.baseUserInfoVo)
                },
              },
            },
            [_vm._v("\n        发积分\n      ")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "member-info-box-content" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "text" },
              on: {
                click: function ($event) {
                  return _vm.openStatisticsDialog(1)
                },
              },
            },
            [_vm._v("\n        " + _vm._s(_vm.memberInfo.score) + "\n      ")]
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "member-info-box" }, [
      _vm._m(1),
      _c(
        "div",
        { staticClass: "member-info-box-content" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "text" },
              on: {
                click: function ($event) {
                  return _vm.openStatisticsDialog(2)
                },
              },
            },
            [_vm._v("\n        " + _vm._s(_vm.memberInfo.exp) + "\n      ")]
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "member-info-box" }, [
      _c(
        "div",
        { staticClass: "member-info-box-title" },
        [
          _c("div", [_vm._v("可用优惠券")]),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "has-permi",
                  rawName: "v-has-permi",
                  value: ["user_send_coupon"],
                  expression: "['user_send_coupon']",
                },
              ],
              staticStyle: { "margin-left": "8px" },
              attrs: { size: "mini", type: "text" },
              on: {
                click: function ($event) {
                  return _vm.handleCoupon(_vm.baseUserInfoVo)
                },
              },
            },
            [_vm._v("\n        发券\n      ")]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "member-info-box-content" }, [
        _c("div", { staticClass: "member-info-box-text" }, [
          _vm._v(_vm._s(_vm.memberInfo.couponCount)),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "member-info-box-title" }, [
      _c("div", [_vm._v("会员等级")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "member-info-box-title" }, [
      _c("div", [_vm._v("成长值")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }